import React from "react";

const Jobs = () => {
  return (
    <>
      {/* Countries / Jobs Start */}
      <div className="container-xxl py-5 destination">
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-white text-center text-primary px-3">
              Countries
            </h6>
            <h1 className="mb-5">Popular Job Destinations</h1>
          </div>

          <div className="row g-3">
            {/* --- NEW TOP SECTION: ROMANIA & BELARUS --- */}
            <div
              className="col-lg-6 col-md-12 wow zoomIn"
              data-wow-delay="0.1s"
            >
              <a className="position-relative d-block overflow-hidden" href="#">
                <img
                  className="img-fluid w-100"
                  src="https://explore-live.s3.eu-west-1.amazonaws.com/medialibraries/explore/explore-media/destinations/europe/romania/romania-header.jpg?ext=.jpg&width=1920&format=webp&quality=80&v=201704211421%201920w"
                  alt="Romania"
                  style={{ height: "300px", objectFit: "cover" }}
                />
                {/* Smaller Badge */}
                <div
                  className="bg-white text-success fw-bold position-absolute top-0 start-0 m-3 py-1 px-2"
                  style={{ fontSize: "0.85rem" }}
                >
                  Skilled and unskilled
                </div>
                {/* Larger Title */}
                <div className="bg-white text-primary fw-extrabold position-absolute bottom-0 end-0 m-3 py-2 px-3 fs-4">
                  Romania
                </div>
              </a>
            </div>
            <div
              className="col-lg-6 col-md-12 wow zoomIn"
              data-wow-delay="0.3s"
            >
              <a className="position-relative d-block overflow-hidden" href="#">
                <img
                  className="img-fluid w-100"
                  src="https://www.idea.int/democracytracker/sites/default/files/2023-02/Belarus-1.jpg"
                  alt="Belarus"
                  style={{ height: "300px", objectFit: "cover" }}
                />
                <div
                  className="bg-white text-success fw-bold position-absolute top-0 start-0 m-3 py-1 px-2"
                  style={{ fontSize: "0.85rem" }}
                >
                  Skilled and unskilled
                </div>
                <div className="bg-white text-primary fw-extrabold position-absolute bottom-0 end-0 m-3 py-2 px-3 fs-4">
                  Belarus
                </div>
              </a>
            </div>

            {/* --- GULF COUNTRIES SECTION --- */}
            <div className="col-lg-12 col-md-12">
              <div className="row g-3">
                <div
                  className="col-lg-4 col-md-6 wow zoomIn"
                  data-wow-delay="0.5s"
                >
                  <a
                    className="position-relative d-block overflow-hidden"
                    href="#"
                  >
                    <img
                      className="img-fluid"
                      src="https://images.unsplash.com/photo-1728622335825-2b2dd67cbf5f?w=600"
                      alt="Saudi Arabia"
                    />
                    <div
                      className="bg-white text-success fw-bold position-absolute top-0 start-0 m-3 py-1 px-2"
                      style={{ fontSize: "0.85rem" }}
                    >
                      High Demand
                    </div>
                    <div className="bg-white text-primary fw-extrabold position-absolute bottom-0 end-0 m-3 py-2 px-3 fs-5">
                      Saudi Arabia
                    </div>
                  </a>
                </div>
                <div
                  className="col-lg-4 col-md-6 wow zoomIn"
                  data-wow-delay="0.7s"
                >
                  <a
                    className="position-relative d-block overflow-hidden"
                    href="#"
                  >
                    <img
                      className="img-fluid"
                      src="https://images.unsplash.com/photo-1580674684081-7617fbf3d745?w=600"
                      alt="UAE"
                    />
                    <div
                      className="bg-white text-success fw-bold position-absolute top-0 start-0 m-3 py-1 px-2"
                      style={{ fontSize: "0.85rem" }}
                    >
                      Urgent Hiring
                    </div>
                    <div className="bg-white text-primary fw-extrabold position-absolute bottom-0 end-0 m-3 py-2 px-3 fs-5">
                      UAE
                    </div>
                  </a>
                </div>
                <div
                  className="col-lg-4 col-md-6 wow zoomIn"
                  data-wow-delay="0.9s"
                >
                  <a
                    className="position-relative d-block overflow-hidden"
                    href="#"
                  >
                    <img
                      className="img-fluid"
                      src="https://images.unsplash.com/photo-1647252262017-582a7dbb73d0?w=600"
                      alt="Qatar"
                    />
                    <div
                      className="bg-white text-success fw-bold position-absolute top-0 start-0 m-3 py-1 px-2"
                      style={{ fontSize: "0.85rem" }}
                    >
                      Multiple Jobs
                    </div>
                    <div className="bg-white text-primary fw-extrabold position-absolute bottom-0 end-0 m-3 py-2 px-3 fs-5">
                      Qatar
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Countries / Jobs End */}
    </>
  );
};

export default Jobs;
